import { RegenerateMenu } from '@/components/session/RegenerateMenu';
import { Button } from '@/components/ui/button';
import { Eye, Loader2, Maximize2 } from 'lucide-react';
import { noteToolbarIconClasses } from './noteInstructions.styles';
import type { NoteToolbarControlsProps } from './noteInstructions.types';

export const NoteToolbarControls = ({
  onRegenerate,
  regenerateDisabled,
  onExpand,
  onEditTemplate,
  isLoadingTemplate,
}: NoteToolbarControlsProps) => (
  <>
    {onRegenerate && <RegenerateMenu onSelect={onRegenerate} disabled={regenerateDisabled} iconOnly />}
    {onExpand && (
      <Button
        size="icon"
        variant="ghost"
        className={noteToolbarIconClasses}
        aria-label="Opna í stórum glugga"
        title="Opna í stórum glugga"
        onClick={onExpand}
      >
        <Maximize2 className="h-4 w-4" />
      </Button>
    )}
    {onEditTemplate && (
      <Button
        size="icon"
        variant="ghost"
        className={noteToolbarIconClasses}
        aria-label="Skoða og breyta sniðmáti"
        title="Skoða og breyta sniðmáti"
        disabled={isLoadingTemplate}
        onClick={onEditTemplate}
      >
        {isLoadingTemplate ? <Loader2 className="h-4 w-4 animate-spin" /> : <Eye className="h-4 w-4" />}
      </Button>
    )}
  </>
);
